import { useState } from 'react';
import { useEventListener } from 'ahooks';

const useHeaderViewWhenScroll = (elementRef = document) => {
  const [isChangeHeaderView, setIsChangeHeaderView] = useState(false);

  const handleDocumentScroll = () => {
    if (window.pageYOffset > 0) {
      setIsChangeHeaderView(true);
    } else {
      setIsChangeHeaderView(false);
    }
  };

  useEventListener('scroll', handleDocumentScroll, {
    target: elementRef,
  });

  return {
    isChangeHeaderView,
  };
};

export default useHeaderViewWhenScroll;
